import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { Creators as toastActions } from '../../store/ducks/toast';
import { Portal } from '../../components-reactjs/Portal';
import Toast from './Toast';

import styles from './styles';

class Toasts extends Component {
    render() {
        return (
            <Portal>
                <div style={styles.container}>
                    {this.props.toasts.map((toast) => {
                        const { id } = toast;

                        return (
                            <Toast
                                {...toast}
                                key={`toast-${id}`}
                                onHandler={() => this.removeToast(id)}
                            />
                        );
                    })}
                </div>
            </Portal>
        );
    }

    removeToast(id) {
        this.props.removeToast(id);
    }
}

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(toastActions, dispatch);

const mapStateToProps = (state) => ({
    toasts: state.toast
});

export default connect(mapStateToProps, mapDispatchToProps)(Toasts);
